import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'next/router';
import {
  contentType,
  contentfulConstant,
  bazaarVoiceFileName,
  productsFileName
} from '../../constants/global';
import config from '../../config';
import PLPConstants from '../../components/Brand/ProductListingPage/constants';
import PLPStore from '../../store/PLPStore';
import {getProducts} from '../../services/algolia.adapter'
import { defaultLangKey } from '../../constants/languages';
import { renderSection } from '../../utils/uiHelper';
import getInitialData from '../../utils/helpers/initialDataHelper';
import DOMIdentifier from '../../utils/domIdentifier';
import PGDataLayer from '../../components/Generic/PGDataLayer/PGDataLayer';
import PageMetadata from '../../components/Generic/PageMetadata';
import Breadcrumb from '../../components/Brand/Shared/Breadcrumb';
//import ProductListingPage from '../../components/Brand/ProductListingPage';
import styles from '../../components/Brand/ProductListingPage/ProductList-tw-styles';
import {formatFilters} from '../../utils/algolia/algolia-util';
import getFilteredData from '../../utils/getFilteredData';
import LazyLoad from 'react-lazy-load';
import ProductListingPage from '../../components/Brand/ProductListingPage';




class ProductListing extends Component {
  static propTypes = {
    pageContext: PropTypes.oneOfType([PropTypes.object]).isRequired,
    productListPageData: PropTypes.oneOfType([PropTypes.object]).isRequired,
    router: PropTypes.oneOfType([PropTypes.object]).isRequired,
    products_list: PropTypes.oneOfType([PropTypes.array]).isRequired,
  };

  static async getInitialProps({ query }) {
    const { locale } = query;
    const pageNumber = query.path.split('-page-')[1];
    const pageSlug = query.slug;
    let data = await getInitialData(
      contentfulConstant,
      contentType.productListPage,
      locale || defaultLangKey,
      query
    );
    let allBvReviews = await getInitialData(
      bazaarVoiceFileName,
      bazaarVoiceFileName,
      query.locale || defaultLangKey
    );

    const productsDataResponse = await getInitialData(
      productsFileName,
      productsFileName,
      query.locale || defaultLangKey
    );
    let productsData = Array.isArray(productsDataResponse)
      ? productsDataResponse
      : [];

    if (!productsData.length) {
      const contentfulProducts =
        (data.data && data.data.productCollection && data.data.productCollection.items) ||
        [];

      productsData = contentfulProducts.map(product => {
        const facets =
          (product.fecetCollection && product.fecetCollection.items) || [];
        const facetMap = {};

        facets.forEach(facet => {
          const facetKey =
            facet && facet.facetCategory && facet.facetCategory.uniqueId;
          if (!facetKey) return;
          if (!facetMap[facetKey]) facetMap[facetKey] = [];
          if (facet.title) facetMap[facetKey].push(facet.title);
        });

        return {
          gtin: product.gtin,
          heroImage:
            (product.heroImage && product.heroImage.url) || product.heroImage,
          heroImageDescription:
            (product.heroImage && product.heroImage.description) || '',
          productName: product.productName,
          productShortName: product.productShortName || product.productName,
          slug: product.slug,
          shortDescription: product.shortDescription,
          total_review_count: 0,
          ratingAndReviewId: product.ratingAndReviewId || product.gtin,
          rating: 0,
          GAPopularityCount: product.featuredSort || 0,
          variantsgtin:
            product.variantsCollection && product.variantsCollection.items
              ? product.variantsCollection.items
                  .map(variant => variant && variant.gtin)
                  .filter(Boolean)
              : [],
          ...facetMap,
        };
      });
    }
    let products_list = [];
    let paginationApiData;
    let product_list_arr_objs = [];
    let hash;
    let page = pageNumber ? pageNumber : 1;
    let asPath1;
    let applyedFilterList = [...PLPConstants.filter_list];
    let recent_applied_facet_category = [];
    let filter_object = { ...PLPConstants.filter_list[0] };

    if (query.path.includes('-page-')) {
      asPath1 = query.path.split('-page-')[0];
      hash = query.path.split('-page-')[1];
    } else {
      asPath1 = query.path;
      hash = '';
    }
    if (
      hash == '' &&
      data.data.productListCollection.items[0].facetCategory != null
    ) {
      let facet = {
        [data.data.productListCollection.items[0].facetCategory.uniqueId]: [
          data.data.productListCollection.items[0].facet.name,
        ],
      };
      filter_object.filter = facet;
      applyedFilterList[0].filter = filter_object.filter;
    } else if (
      hash == '' &&
      data.data.productListCollection.items[0].facetCategory == null
    ) {
      let facet = {};
      filter_object.filter = facet;
      applyedFilterList[0].filter = filter_object.filter;
    } else if (
      hash != '' &&
      data.data.productListCollection.items[0].facetCategory != null
    ) {
      let facet = {
        [data.data.productListCollection.items[0].facetCategory.uniqueId]: [
          data.data.productListCollection.items[0].facet.name,
        ],
      };
      filter_object.filter = facet;
      applyedFilterList[0].filter = filter_object.filter;
    }
    if (pageNumber) {
      let page = pageNumber;
      page = parseInt(page, 10);
      PLPConstants.algoliaQueryFormat.page = page-1;
      applyedFilterList[0].page = page;
      PLPStore.applyedFilterList[0].page = page;
    } else if (pageNumber == undefined) {
      let page = 1;
      PLPConstants.algoliaQueryFormat.page = page-1;
      applyedFilterList[0].page = page;
      PLPStore.applyedFilterList[0].page = page;
    }
    const algoliaQuery = { ...PLPConstants.algoliaQueryFormat};
    let product_search_query = Object.assign({}, algoliaQuery);
    if (applyedFilterList[0].filter.length == '0') {
      recent_applied_facet_category = '';
    }
    /*** filter query **/
    if (!data.data.productListCollection.items[0].slug.includes('produtos')) {
      product_search_query.filters = applyedFilterList[0].filter
    }
    /*** sorting */
    let current_sorting_constants=PLPConstants.sorting_dropdown_list['newest']
    if (applyedFilterList[0].sort) 
      current_sorting_constants =
        PLPConstants.sorting_dropdown_list[applyedFilterList[0].sort];
    
    await getFilteredData(productsData, {
      ...product_search_query,
      ...current_sorting_constants,
    }) 
      .then(data => {

          const totalProductCount = data.nbHits;
          let updated_product_list = data.hits;
          updated_product_list = updated_product_list.map(product => {
            const product_object = {
              id: product.gtin,
              title: product.productShortName,
              image: {
                url: product?.heroImage,
                description: product?.heroImageDescription,
              },
              link: product.slug,
              rating: product.rating,
              description: product.shortDescription,
              ratingCount: product.total_review_count,
              callToActions: null,
              checked: false,
              ratingAndReviewId: product.ratingAndReviewId,
              productCategoryType: product.productCategoryType,
              variantsgtin: product.variantsgtin,
            };
            products_list.push(product_object);
          });
          let pageWiseArticlesObj = {
            products: products_list,
            pageNumber: page,
          };
          product_list_arr_objs.push(pageWiseArticlesObj);
          products_list = [...product_list_arr_objs];
          paginationApiData = data;

      })
      .catch(e => {});
    let currentUrl = decodeURIComponent(query.path);
    let pageQueryParam;
    let nextUrl = config.siteUrl + currentUrl;
    let previousUrl = config.siteUrl + currentUrl;
    return {
      data: data.data || {},
      allBvReviews,
      pageContext: query,
      pageSlug: pageSlug,
      apiData: paginationApiData,
      products_list: products_list,
      pageNumber: pageNumber,
      nextUrl: nextUrl,
      prevUrl: previousUrl,
      productsData
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      bv_data: this.bazarVoiceDataFormation(),
      isMobile : typeof window !== 'undefined'? window.innerWidth < 767 : false
    };
  }
  componentDidMount() {
    DOMIdentifier.addClassToBody('productlistingpage');
  }

  componentWillUnmount() {
    DOMIdentifier.removeClassToBody('productlistingpage');
  }
  stripTrailingSlash = url => {
    return url.endsWith('/') ? url.slice(0, -1) : url;
  };
  bazarVoiceDataFormation() {
    // BV plugin data formation
    const { allBvReviews } = this.props;
    let BV_Data = {};
    allBvReviews &&
      allBvReviews.forEach(node => {
        if (
          node.productId != null &&
          node.productId != 'null' &&
          node.productId != 'undefined'
        ) {
          BV_Data[node.productId] = {
            TotalReviewCount:
              node.TotalReviewCount != null && node.TotalReviewCount != 'null'
                ? node.TotalReviewCount.toFixed(2)
                : 0,
            AverageOverallRating:
              node.ReviewStatistics.AverageOverallRating != null &&
              node.ReviewStatistics.AverageOverallRating != 'null'
                ? node.ReviewStatistics.AverageOverallRating.toFixed(2)
                : 0,
          };
        }
      });
    return BV_Data;
    }
    
  loadProductList(children) {
    const { router } = this.props;
    const isProductDetailsLoaded = router?.query?.slug === 'produtos';
    if (isProductDetailsLoaded) return children;
    else return <LazyLoad offset={-50}><>{children}</></LazyLoad>;
  }


  
  render() {
    const {
      pageContext,
      data,
      router,
      pageNumber,
      products_list,
      nextUrl,
      pageSlug,
      prevUrl,
    } = this.props;
    let pageData = data.productListCollection.items[0];
    PLPStore.applyedFilterList[0].page = pageNumber ? parseInt(pageNumber) : 1;
    const { bv_data } = this.state;
    return (
      <React.Fragment>
        {pageData && pageData.pageMetadata && (
          <PGDataLayer
            locale={pageContext.locale}
            pageType={contentType.productPage}
            data={data}
            path={router.asPath}
            title={pageData.pageMetadata && pageData.pageMetadata.pageTitle}
          />
        )}
        {pageData.pageMetadata && (
          <PageMetadata
            title={pageData.pageMetadata.pageTitle}
            metaTitle={pageData.pageMetadata.metaTitle}
            metaDescription={
              pageData.pageMetadata.metaDescription &&
              pageData.pageMetadata.metaDescription
            }
            orgTitle={pageData.pageMetadata.openGraphPageTitle}
            orgDescription={pageData.pageMetadata.openGraphDescription}
            metaKeywords={
              pageData.pageMetadata.metaKeywords &&
              pageData.pageMetadata.metaKeywords
            }
            nextUrl={nextUrl && nextUrl}
            prevUrl={prevUrl && prevUrl}
          />
        )}
        <div className={classNames(styles?.productList?.breadcrumbContainer)}>
          <Breadcrumb locale={pageContext.locale} currentUrl={router.asPath} />
        </div>
        {pageData &&
          pageData.pageContentCollection &&
          pageData.pageContentCollection.items.map(sectionItem => {
            return <div>{renderSection(sectionItem, pageContext)}</div>;
          })}
          {this.loadProductList(
            <ProductListingPage
              locale={pageContext.locale}
              pageData={pageData}
              currentUrl={router.asPath}
              facetCategory={pageData.facetCategory}
              products_list={products_list}
              pageSlug={pageSlug}
              {...this.props}
              PLPStore={PLPStore}
              bv_data={bv_data}
            />
          )}
        
      </React.Fragment>
    );
  }
}
// NextJS has a different routing structure. We wrap all pages components with withRouter HOC
// So that they receive the router prop which is almost equivalent to the location prop in gatsby
export default withRouter(ProductListing);
